import useEntity from "../../hooks/useCordwoodHistory";
import CordwoodHistoryDetail from "../../components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryDetail";
import CordwoodHistoryScoped from "../../components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryScoped";
import CordwoodHistoryTabs from "../../components/cordwoodHistory/CordwoodHistoryDetail/CordwoodHistoryTabs";
import { useGetCordwoodHistoryQuery } from "../../apis/CordwoodHistory.api";
import { PrimaryCordwoodHistory } from "../../types/models/CordwoodHistory";
import React from "react";
import {Delete, Edit} from "@mui/icons-material";
import {Box, Paper, Stack, Button} from "@mui/material";
import {NavLink, useParams, useSearchParams} from "react-router";
import {useStateSession} from "../../../hooks/useAuth";
import {useTitle} from 'react-use';
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CordwoodHistoryDetailPage = () => {

    useTitle(t`Details Cordwood History`);

    const session = useStateSession()
    const [searchParams] = useSearchParams();
    const scoped = searchParams.get("scoped");
    const { cordwoodHistoryId: id } = useParams();

    const { data, refetch } = useGetCordwoodHistoryQuery(PrimaryCordwoodHistory.fromPath(id))
    const { deleteCordwoodHistory } = useEntity();

    const onDelete = React.useCallback((e: any) => {
        e.stopPropagation()
        deleteCordwoodHistory(data, '..')
    }, [data, deleteCordwoodHistory])

    if (id === 'scoped') {
        return (<CordwoodHistoryScoped/>)
    }

    return (
        <Box data-testid="CordwoodHistory-details">
            { data && <Paper sx={ { padding: "2em" } }>
                <CordwoodHistoryDetail data={data} refetch={refetch} scoped={scoped}/>
                <Stack direction="row" justifyContent="center" spacing={1} sx={ { marginTop: "2em" } }>
                    
                    { (session.hasPermission(
            data.scopeGroupId,
            'applications/timber/entities/CordwoodHistories/delete/view'
        ) ||
false) &&
                        <Button size="small" color="error" variant="outlined" data-testid="CordwoodHistory-delete-button" startIcon={<Delete />}  onClick={(e) => onDelete(e)}>
                            <Trans>Delete</Trans>
                        </Button>
                    }
                </Stack>
            </Paper>}

            { data && <Stack direction="row" spacing={1} sx={ { marginTop: "2em" } }>
                <CordwoodHistoryTabs data={data} />
            </Stack>}
        </Box>
    )
}

export default CordwoodHistoryDetailPage;
